import { ListItem } from '@fs/zion-ui'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'
import { assignMemberAsAdmin } from '../../../services/updateMemberStatus'

export default function AssignAdminListItem({
  groupId,
  member,
  onAssignAdmin,
  adminCount,
  isResearcherTree,
  assignAsCoOwnerOverlay,
}) {
  const [t] = useTranslation()
  const [loading, setLoading] = useState(false)
  const isCurrent = useRef(true)

  useEffect(() => {
    isCurrent.current = true
    return () => {
      isCurrent.current = false
    }
  })

  const onClick = () => {
    setLoading(true)
    assignMemberAsAdmin(groupId, member.memberCisId)
      .then(() => onAssignAdmin())
      .catch((e) => {
        isCurrent.current && setLoading(false)
        console.error(e)
      })
  }

  return (
    <ListItem
      disabled={adminCount === 3 || loading}
      startElement={loading ? <ListItem.Icon Icon={NoticeLoading} /> : undefined}
      primaryText={t(
        isResearcherTree ? 'group-management.assign-co-owner.action' : 'group-management.assign-administrator.action'
      )}
      onClick={isResearcherTree ? assignAsCoOwnerOverlay.handleClick : onClick}
      data-testid="assign-as-admin-button"
    />
  )
}
